import { Winners } from 'constants/common';

export enum ACTIONS {
  SET_WIN_STATUS = 'SET_WIN_STATUS',
}

export interface IWinStatusState {
  winner: Winners;
  winningAmount: number;
  betAmount: number;
}
